import type { CSSProperties } from 'react';

/** Stagger index for an `lp-reveal` child: its reveal starts `i` × 60ms late. */
export const stagger = (i: number) => ({ '--i': i }) as CSSProperties;
